import { isRegion } from "@/lib/regions/client";
import { cableCarStopIds } from "@/lib/transitData";

export default function checkStopType(sms) {
  if (sms) {
    if (isRegion("chch")) {
      return "bus";
    }

    if (isNaN(sms)) {
      if (cableCarStopIds.includes(sms)) {
        return "cable_car";
      } else {
        return "train";
      }
    } else {
      if (sms >= 9995) {
        return "ferry";
      } else {
        return "bus";
      }
    }
  }
  return undefined;
}
